<template>
 <div class="member-list bg-white">
   <div class="container-fluid">
     <sidebar />
      <div v-if="deleteMsg">
          {{statusAlert(true)}}
      </div>
     <div class="col-md-9 col-lg-10 ml-md-auto py-4">
     <memberList v-if="allMember"/>
     </div>
   </div>
 </div>
</template>

<script>
import sidebar from '@/components/_sidebar/sidebar'
import memberList from './components/memberList'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  created () {
    this.getAllMember()
    this.getMemberRegistrationDates()
  },
  computed: {
    ...mapState('latestMember', ['allMember', 'memberRegistrationDates']),
    ...mapState('adminEditMember', ['deleteMsg'])
  },
  methods: {
    ...mapActions('latestMember', ['getAllMember', 'getMemberRegistrationDates']),
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.deleteMsg,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  components: {
    sidebar,
    memberList
  }
}
</script>
